import { Button } from '@consta/uikit/Button'
import { Text } from '@consta/uikit/Text'
import type { FC, MouseEventHandler } from 'react'

import css from './StepChooseTargetWells.css'

type ChosenControlProps = {
  chosenCount: number
  onChooseAll: MouseEventHandler
  onReset: MouseEventHandler
}

export const ChosenControl: FC<ChosenControlProps> = ({ chosenCount, onChooseAll, onReset }) => {
  return (
    <div className={css.chosenControl}>
      <Text size="xs" view="secondary">
        Выбрано: {chosenCount}
      </Text>
      <div>
        <Button label="Выбрать все" view="clear" size="xs" onClick={onChooseAll} />
        <Button label="Сбросить" view="clear" size="xs" onClick={onReset} />
      </div>
    </div>
  )
}
